import * as tslib_1 from "tslib";
import React from 'react';
import { withTranslation } from 'react-i18next';
import FormPopup from '../../Popup/Form';
import DaEditorWrapper from '../LoadableDaEditorWrapper';
import LoadingIndicator from '../../LoadingIndicator';
import s from './MobileFullscreenPopup.scss';
var DaEditorMobileFullscreenPopup = /** @class */ (function (_super) {
    tslib_1.__extends(DaEditorMobileFullscreenPopup, _super);
    function DaEditorMobileFullscreenPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleEditorInit = function (toolbars, api) {
            _this.setState({ toolbars: toolbars });
        };
        _this.handleContentChange = function (rawContentState, editorContent, featuresData) {
            _this.rawContentState = rawContentState;
            _this.editorContent = editorContent;
            _this.featuresData = featuresData;
        };
        _this.handleSubmit = function () {
            _this.props.onDone(_this.rawContentState, _this.editorContent, _this.featuresData);
        };
        _this.getSideToolbar = function () {
            if (_this.state && _this.state.toolbars && _this.state.toolbars.SIDE) {
                var Side = _this.state.toolbars.SIDE;
                return (React.createElement("div", { className: s['header-tools'] },
                    React.createElement(Side, null)));
            }
            return null;
        };
        return _this;
    }
    DaEditorMobileFullscreenPopup.prototype.render = function () {
        var _a = this.props, charLimit = _a.charLimit, flavour = _a.flavour, isOpen = _a.isOpen, title = _a.title, t = _a.t, onCancel = _a.onCancel, placeholder = _a.placeholder, theme = _a.theme, initialContent = _a.initialContent, fixedParagraph = _a.fixedParagraph;
        return (React.createElement(FormPopup, { isOpen: isOpen, title: title || '', className: s['fullscreen-popup'], headerClassName: s['header'], footerClassName: s['footer'], headerExtras: this.getSideToolbar(), submitBtnLabel: t('common.done'), withContentPaddings: false, withCloseButton: false, onSubmit: this.handleSubmit, onCancel: onCancel },
            React.createElement("div", { className: s['content-wrap'] },
                React.createElement(DaEditorWrapper, { loadingComponent: LoadingIndicator, placeholder: placeholder, flavour: flavour, onEditorInit: this.handleEditorInit, onContentChange: this.handleContentChange, theme: theme, initialContent: initialContent, fixedParagraph: fixedParagraph, filterPaste: true, charLimit: charLimit }))));
    };
    return DaEditorMobileFullscreenPopup;
}(React.Component));
export { DaEditorMobileFullscreenPopup };
export default withTranslation()(DaEditorMobileFullscreenPopup);
//# sourceMappingURL=MobileFullscreenPopup.js.map